import React from "react";
import "./Common_Heading.css";

const Common_Heading = ({ head1, head2, title_text }) => {
  return (
    <>
      <div className="headings">
        <div className="title-holder">
          <p> {title_text}</p>
        </div>
        <h2 className="common-heading">
          {head1}
          <br />
          <span>{head2}</span>
        </h2>
      </div>
    </>
  );
};

export default Common_Heading;
